import type { Signal } from '@angular/core';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import type { AppIdentity } from '@evc/platform';
import { PlatformComponent, PlatformService } from '@evc/platform';
import { type Maybe } from '@evc/web-components';
import { FooterComponent } from '@shared/components/footer/footer';
import { SharedConfigService } from '@shared/services/config/config.service';
import { I18nService } from '@shared/services/i18n/i18n.service';

@Component({
  standalone: true,
  imports: [RouterModule, PlatformComponent, FooterComponent],
  selector: 'evc-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  #router = inject(Router);
  #config = inject(SharedConfigService);
  #platformService = inject(PlatformService);
  protected i18nService = inject(I18nService);
  protected ready: Signal<Maybe<true>> = this.#platformService.ready;

  #appName = this.#config.getComputed('APP_NAME');
  appIdentification = computed<AppIdentity>(() => {
    const app = {
      title: (this.#appName() ?? '').toUpperCase(),
      logo: '../assets/logos/evident-connect-imagotype.svg#evident-connect-imagotypeconnect-imagotypeconnect-imagotype',
      onTitleClick: () => this.#router.navigateByUrl(''),
    };

    return app;
  });
}
